import { ref, watchEffect } from 'vue'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useI18n } from '@/hooks/web/useI18n'
import { buildDocumentTitle, resolveAppTitle } from '@/utils/appBrand'

const pageTitleKey = ref<string | undefined>()
let documentTitleInited = false

/** 路由切换时更新当前页 i18n key，并与系统名称拼接窗口标题 */
export const useTitle = (newTitle?: string) => {
  if (newTitle !== undefined) {
    pageTitleKey.value = newTitle
  }

  if (documentTitleInited) {
    return
  }
  documentTitleInited = true

  const { t } = useI18n()
  const appStore = useAppStoreWithOut()

  watchEffect(() => {
    const systemName = resolveAppTitle(appStore.title)
    const pageName = pageTitleKey.value ? t(pageTitleKey.value as string) : ''
    if (typeof document !== 'undefined') {
      document.title = buildDocumentTitle(systemName, pageName)
    }
  })
}
